import { GetterTree, ActionTree, MutationTree } from 'vuex'
import { ar, es, uy, cl } from './data'

class State {
    countries: any[] = [
        { name: ar.name, code: ar.code, flag: ar.flag },
        { name: es.name, code: es.code, flag: es.flag },
        { name: uy.name, code: uy.code, flag: uy.flag },
        { name: cl.name, code: cl.code, flag: cl.flag }
    ]
    country: any = {}
}

const getters: GetterTree<State, any> = {
    countries: (state) => state.countries,
    country: (state) => state.country
}

const mutations: MutationTree<State> = {
    countryHandler: (state, payload) => {
        if (payload === 'AR') {
            state.country = ar
        } else if (payload === 'ES') {
            state.country = es
        } else if (payload === 'UY') {
            state.country = uy
        } else if (payload === 'CL') {
            state.country = cl
        }
    }
}

const actions: ActionTree<State, any> = {}

export default {
    namespaced: true,
    state: new State(),
    mutations,
    actions,
    getters
}
